<style>
  .exc-viewer-button-right {
    background-color: rgba(0, 0, 0, 0.5);;
    line-height: 150px;
    border-radius: 0 5px 5px 0;
    width: 24px;
    text-align: center;
    margin-right: 8px;
  }

  .exc-viewer-button-left {
    background-color: rgba(0, 0, 0, 0.5);;
    line-height: 150px;
    border-radius: 5px 0 0 5px;
    width: 24px;
    text-align: center;
    margin-left: 8px;
  }

  .exc-viewer-button-right:hover, .exc-viewer-button-left:hover {
    cursor: pointer;
    color: white;
    background-color: rgba(0, 0, 0, 0.7);
  }
</style>
<div class="modal-body modal-max">
  <div class="layout-auto-1-auto">
    <span class="modal-header">{{getRessource('DocumentHeader')}}</span>
    <div class="content">
      <div class="grid-auto-1-auto grid-full-height">
        <div class="exc-viewer-button-left" [class.disabled]="currentIndex <= 0" (click)="showPrev()">
          <i class="fas fa-fw fa-caret-left"></i>
        </div>
        <div class="content">
          <div class="layout-auto-1">
            <div class="grid cols-2">
              <div>
                <exg-select *ngIf="excSecurity.isFeatured('DEVELOPMENT')" #t name="DokTypeSelect"
                            caption="{{enumSvc.getFieldCaption('Dokument','dok_enmIdent_DokTyp')}}"
                            [ngModel]="uiSelectDocumentTypeIndex"
                            (ngModelChange)="setDocumentType($event); t.closed=true"
                            [list]="enumSvc.getEnumerationList('DokTyp')"
                            listdisplay="enmText">
                </exg-select>
              </div>
              <div style="text-align: right">
                <button (click)="downloadDocument()" class="md-btn download-btn"><i
                  class="far fa-2x fa-file-download"></i>
                </button>
              </div>
            </div>
            <div class="layout-auto-1">
              <div style="text-align: center; line-height: 2rem">{{currentItem?.dokName}}{{currentItem?.dokErw}}</div>
              <div class="content" style="background: var(--c-dark-m1)">
                <div *ngIf="isLoading" class="loading-animation" style="z-index: 10;">
                  <i class="fas fa-spinner-third fa-spin"></i>
                </div>
                <div *ngIf="!isLoading && galleryDataCount === 0">
                  <div class="splash empty"><p>{{getRessource('NoGalleryData')}}</p></div>
                </div>
                <div *ngIf="notSupportedMIME" class="grid-full-height gh-ai-center"
                     style="font-family:Roboto,Arial, Helvetica, sans-serif!important; align-items: center">
                  <h3 class="not-supported-mime"
                      style="color: white; text-align: center;">{{getRessource('NotSupportedMIME', {fileName: currentItem?.dokName})}}</h3>
                </div>
                <div *ngIf="!notSupportedMIME && !isLoading && galleryDataCount !== 0" class="host-container" style="height: 100%"
                     [class.center-video]="currentItem && isCurrentItemVideo()">
                  <img #imgHost class="host-image-view"
                       *ngIf="currentItem && isCurrentItemImage()"
                       data-scale="1" [src]="currentResource || ''"
                       [alt]="currentItem?.dokName">
                  <video *ngIf="currentItem && isCurrentItemVideo()" #vidHost class="host-video-view"
                         style="height: 100%; width: 100%; max-height: 90%;max-width: 90%;" controls>
                    <source [src]="currentResource || ''" [type]="currentItem?.dokMIME"/>
                    {{getRessource('NotSupportedVideo')}}
                  </video>
                  <div *ngIf="currentItem && isCurrentItemPDF()" style="height: 100%;">
                    <div class="pdf-viewer-box" style="height: 1px;">
                      <pdf-viewer class="host-pdf-view" style="display: block;"
                                  [src]="currentResource || null"
                                  [render-text]="false" [original-size]="true" [fit-to-page]="true"
                                  [show-borders]="true"
                                  [show-all]="true"></pdf-viewer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="exc-viewer-button-right" [class.disabled]="currentIndex >= galleryDataCount -1"
             (click)="showNext()">
          <i class="fas fa-fw fa-caret-right"></i>
        </div>
      </div>
    </div>
    <div class="spawn-modal-actions">
      <button (click)="close()" class="md-btn">
        {{getGlobal('Cancel')}}
      </button>
      <button *ngIf="excSecurity.isFeatured('DEVELOPMENT')" (click)="save()" class="md-btn">
        {{getResource('Save')}}
      </button>
      <button *ngIf="galleryDataCount > 0 && data.CustomAction" (click)="customAction(currentItem)" class="md-btn">
        {{data.CustomAction.caption}}
      </button>
    </div>
  </div>
</div>
